import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { LayoutsModule } from "./layouts/layouts.module";

// Auth
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";
//import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";

// Language
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { SharedModule } from "./shared/shared.module";
import { LoadingInterceptor } from "./core/helpers/loading.interceptor";
import { AgencyContextInterceptor } from "./core/helpers/agency-context.interceptor";
import { LanguageService } from "./core/services/language.service";
import { ToastrModule } from 'ngx-toastr';

const initializer = (langService: LanguageService) => () => langService.init();
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(
    http,
    `${environment.apiUrl}/languages/`,
    ".json"
  );
}
//import {APP_BASE_HREF} from '@angular/common';
@NgModule({
  declarations: [AppComponent],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    SharedModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      tapToDismiss: false,
      timeOut: 0,               
      extendedTimeOut: 0,
      closeButton: true,
      progressBar: true,
    }),


  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    // Depois do JwtInterceptor: ver o comentário na classe.
    { provide: HTTP_INTERCEPTORS, useClass: AgencyContextInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [LanguageService],
      multi: true,
    },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // {provide: APP_BASE_HREF, useValue: '/admin'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
